export default __webpack_public_path__ + "static/section-5-img-2-d8978b6d8d1a5782a9569dfc62aa55cd.png";